import { authHeaders } from './apiFetch';

export const addToWishlist = async (productID, csrfToken) => {
    try {
        const response = await fetch('/api/user/wishlist', {
            method: "POST",
            headers: authHeaders({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify({ productID })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error:', error);
    }
};